export class HttpError extends Error {
  /** 0 = sit nedostupna, request vubec neodesel. */
  readonly status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'HttpError'
    this.status = status
  }

  get isOffline(): boolean {
    return this.status === 0
  }
}

/** Kdyz server rekne 401, prihlaseni vyprselo — SessionProvider na to posloucha. */
export const UNAUTHORIZED_EVENT = 'sp:unauthorized'

type Method = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE'

/**
 * Odpovedi se validuji stejnym schematem, jakym je server sestavuje.
 * Kdyz se API rozejde s klientem, pozna se to tady a ne az u sestry v obchode.
 */
export async function request<T>(
  method: Method,
  url: string,
  parse: (data: unknown) => T,
  body?: unknown,
): Promise<T> {
  let res: Response
  try {
    res = await fetch(url, {
      method,
      credentials: 'same-origin',
      headers: {
        accept: 'application/json',
        ...(body !== undefined ? { 'content-type': 'application/json' } : {}),
      },
      ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    })
  } catch {
    // Hlaska je pro uzivatele, proto cesky a srozumitelne.
    throw new HttpError(0, 'Nelze se spojit se serverem')
  }

  if (res.status === 401 && !url.startsWith('/api/auth/')) {
    window.dispatchEvent(new Event(UNAUTHORIZED_EVENT))
  }

  if (!res.ok) {
    let message = `Chyba serveru (${res.status})`
    try {
      const data = (await res.json()) as { error?: unknown }
      if (typeof data.error === 'string') message = data.error
    } catch {
      // telo neni JSON, zustane obecna hlaska
    }
    // Proxy bez spojeni na API (vyvoj, restart kontejneru) vraci 502/504.
    throw new HttpError(res.status === 502 || res.status === 504 ? 0 : res.status, message)
  }

  return parse(await res.json())
}
